<div class="forget__three">
  <div class="auth__header flex flex-col gap-4 text-center">
    <h2 translate>Reset Password</h2>
    <p translate>Choose Your New Password</p>
  </div>

  <form
    class="flex flex-col gap-12 mt-6"
    [formGroup]="form"
    (submit)="submit()"
  >
    <div class="flex flex-col gap-4">
      <input-password
        [options]="{
          label: 'Password',
          control: form.controls.password,
          isShowErrors,
        }"
      ></input-password>
      <input-password
        [options]="{
          label: 'Confirm Password',
          control: form.controls.confirmPassword,
          isShowErrors,
        }"
      ></input-password>
    </div>

    <button class="primary__btn w-full" translate>Reset Password</button>
  </form>
</div>
